import { STATIC_ASSETS_PLACEHOLDER } from "../staticAssetsPlaceholder.js";
const greetingSceneBackground = {
    variant: "plain-color",
    color: "transparent",
};
const images = {
    "background-paper-light": {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/holiday-snow/background-paper-light.png`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/holiday-snow/optimized/background-paper-light.webp`,
        width: 1920,
        height: 1080,
    },
    "clip-tab-red": {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/holiday-snow/clip-tab-red.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/holiday-snow/optimized/clip-tab-red.webp`,
        width: 160,
        height: 160,
    },
    "left-side": {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/holiday-snow/left-side.png`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/holiday-snow/optimized/left-side.webp`,
        width: 1500,
        height: 1500,
    },
    "right-side": {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/holiday-snow/right-side.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/holiday-snow/optimized/right-side.webp`,
        width: 1500,
        height: 1500,
    },
    "snow-1": {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/holiday-snow/snow-1.png`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/holiday-snow/optimized/snow-1.png`,
        width: 1920,
        height: 1080,
    },
    "table-card-small": {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/holiday-snow/table-card-small.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/holiday-snow/optimized/table-card-small.webp`,
        width: 1364,
        height: 724,
    },
};
const greetingTemplate = {
    type: "greetingLinesAsScenes",
    variant: "intro",
    secondsPerCharacter: 0.1,
    minimumMessageDisplayTimeSeconds: 3,
    showLogo: true,
    sceneBackground: greetingSceneBackground,
    messageAssets: [
        [
            {
                url: images["left-side"],
                style: {
                    position: "absolute",
                    right: 0,
                    top: 0,
                    height: "100%",
                    width: "auto",
                    // flipping so we can use the same image for the other side
                    transform: "scaleX(-1)",
                },
            },
            {
                url: images["right-side"],
                style: {
                    position: "absolute",
                    left: 0,
                    top: 0,
                    height: "100%",
                    width: "auto",
                    // flipping so we can use the same image for the other side
                    transform: "scaleX(-1)",
                },
            },
        ],
        [
            {
                url: images["left-side"],
                style: {
                    position: "absolute",
                    left: 0,
                    top: 0,
                    height: "100%",
                    width: "auto",
                },
            },
            {
                url: images["right-side"],
                style: {
                    position: "absolute",
                    right: 0,
                    top: 0,
                    height: "100%",
                    width: "auto",
                },
            },
        ],
        [
            {
                url: images["left-side"],
                style: {
                    position: "absolute",
                    right: 0,
                    top: 0,
                    height: "100%",
                    width: "auto",
                    // flipping so we can use the same image for the other side
                    transform: "scaleX(-1)",
                },
            },
            {
                url: images["right-side"],
                style: {
                    position: "absolute",
                    left: 0,
                    top: 0,
                    height: "100%",
                    // flipping so we can use the same image for the other side
                    transform: "scaleX(-1)",
                },
            },
        ],
    ],
};
const sceneTransition = {
    variant: "imageSequence",
    timing: { variant: "linear", durationSeconds: 1.5 },
    mask: {
        urlPrefix: {
            full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/common/mask/{i}.png`,
            preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/common/optimized/mask/{i}.png`,
        },
        frameCount: 42,
        zeroPad: 2,
    },
    overlay: {
        urlPrefix: {
            full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/common/overlay/{i}.png`,
            preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/common/optimized/overlay/{i}.png`,
        },
        frameCount: 42,
        zeroPad: 2,
    },
};
export const holidaySnow = {
    version: 1,
    themeId: "holiday-snow",
    name: "Holiday Snow",
    endFadeDuration: 1,
    thumbnailFrame: 150,
    thumbnailUrl: `${STATIC_ASSETS_PLACEHOLDER}/compilations/theme-stills/holiday-snow.webp`,
    background: [
        {
            variant: "image",
            color: "#637780",
            src: images["background-paper-light"],
        },
        {
            variant: "image",
            color: "transparent",
            src: images["snow-1"],
        },
    ],
    scenes: [
        {
            type: "textTransition",
            variant: "intro",
            title: {
                text: "titleMessage",
                fontFamily: "Berkshire Swash",
                fontSize: 250,
                fontWeight: "medium",
                letterSpacing: "normal",
                textColor: "#fff",
                transition: "squish-in",
            },
            durationSeconds: 8,
            faceCollage: {
                variant: "top-bottom-static",
                borderShape: "circle",
                colorFilter: "grayscale",
                startAtSeconds: 1,
                entrance: { variant: "zoom-in" },
            },
            leftImage: { url: images["left-side"] },
            rightImage: { url: images["right-side"] },
        },
        {
            ...greetingTemplate,
            variant: "intro",
        },
        {
            type: "clip-series-basic",
            showLogo: true,
        },
        {
            ...greetingTemplate,
            variant: "outro",
        },
        {
            type: "outro",
            colorVariant: "darkBlue",
        },
    ],
    styles: {
        textBox: {
            backgroundColor: "#fff",
            backgroundOpacity: 0,
            backgroundBlur: 2,
            textAlign: "center",
            textColor: "#fff",
            fontFamily: "Berkshire Swash",
            fontWeight: "light",
            fontSize: 90,
            leading: 1.2,
            tracking: 0,
        },
        clips: {
            textVariant: {
                variant: "slide-in-static",
                startOffsetSeconds: 1.5,
                entranceVariant: "jiggle-to-offset-left",
                cards: [
                    {
                        backgroundColor: "#637780",
                        backgroundOpacity: 1,
                        paddingLeft: "3rem",
                        paddingRight: "10rem",
                        paddingTop: "3rem",
                        paddingBottom: "4rem",
                        borderWidth: "20px",
                        borderColor: "#fff",
                        backgroundImages: [
                            {
                                url: images["background-paper-light"],
                            },
                        ],
                        doodleImages: [
                            {
                                url: images["table-card-small"],
                                displaySize: {
                                    width: 600,
                                },
                                style: {
                                    bottom: "0px",
                                    right: "0px",
                                },
                            },
                        ],
                    },
                ],
            },
            betweenTransition: sceneTransition,
            backgroundVariant: {
                variant: "image",
                images: [
                    [
                        {
                            url: images["left-side"],
                            zPosition: "below",
                            transformations: ["flip-x"],
                            top: 0,
                            right: 0,
                            width: "auto",
                            height: "100%",
                        },
                        {
                            url: images["right-side"],
                            zPosition: "below",
                            transformations: ["flip-x"],
                            top: 0,
                            left: 0,
                            width: "auto",
                            height: "100%",
                        },
                    ],
                    [
                        {
                            url: images["left-side"],
                            zPosition: "below",
                            top: 0,
                            left: 0,
                            width: "auto",
                            height: "100%",
                        },
                        {
                            url: images["right-side"],
                            zPosition: "below",
                            top: 0,
                            right: 0,
                            width: "auto",
                            height: "100%",
                        },
                    ],
                ],
            },
            title: {
                backgroundColor: "#fff",
                backgroundOpacity: 1,
                textColor: "#fff",
                fontFamily: "Berkshire Swash",
                fontWeight: "normal",
                fontSize: 70,
                nudge: 2,
                textTransform: "none",
            },
            subtitle: {
                backgroundColor: "#fff",
                backgroundOpacity: 1,
                textColor: "#fff",
                fontFamily: "Berkshire Swash",
                fontWeight: "normal",
                fontSize: 40,
                nudge: 2,
                textTransform: "uppercase",
            },
            scaleFactor: 0.9,
            boxShadow: "0.25rem 0.25rem 1.125rem 0px rgba(0,0,0,0.75)",
            border: "0.25rem solid #232626",
            overlay: {
                variant: "corner",
                url: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/holiday-snow/clip-tab-red.webp`,
                offsetUnit: "-1rem",
            },
        },
        watermark: {
            opacity: 0.8,
            margin: 32,
            enterTransition: {
                variant: "marginSlide",
                direction: "from-left",
                timing: { variant: "linear", durationSeconds: 0.5 },
            },
            exitTransition: {
                variant: "marginSlide",
                direction: "from-left",
                timing: { variant: "linear", durationSeconds: 0.5 },
            },
        },
        sceneTransition,
    },
    userInputFields: [
        {
            id: "titleMessage",
            type: "text",
            label: "Title Message",
            defaultValue: "",
            placeholder: "Happy Holidays!",
            required: true,
            min: 1,
            max: 25,
            preview: {
                sceneIndex: 0,
                frameOffset: 200,
            },
        },
    ],
    colorPalettes: ["HolidaySnow"],
};
